export enum FolderFormTab {
  Address = 'address',
  CodingConfig = 'codingConfig',
  ExternalActors = 'externalActors',
  GeneralInfo = 'generalInfo',
  InternalActors = 'internalActors',
}
